export type PlayerTag = {
  id: string;
  name: string;
};

export type PaymentMethodGeneralLimit = {
  currency: string;
  min: number;
  max: number;
};

export type PaymentMethodExceptionLimit = {
  id: string;
  currency: string;
  type: number;
  min: number | string | null;
  max: number | string | null;
  playerTags: PlayerTag[];
};

export type PaymentMethodCreateExceptionLimit = Omit<PaymentMethodExceptionLimit, 'id'>;

export enum PaymentMethodExceptionLimitType {
  DEPOSIT = 1,
  WITHDRAWAL = 2,
}

export const createDefaultExceptionLimit = <T extends PaymentMethodExceptionLimitType>(
  type: T,
): PaymentMethodCreateExceptionLimit => ({
    currency: '',
    type,
    min: null,
    max: null,
    playerTags: [],
  });

export type ExtendedPaymentMethodExceptionLimit = PaymentMethodGeneralLimit & {
  limitList: PaymentMethodExceptionLimit[];
};

export type PaymentMethodExceptionLimitCreateModel = {
  currency: string;
  type: number;
  min: number;
  max: number;
  playerTags: string[];
};

export type PaymentMethodExceptionLimitCreateRequestPayload = {
  paymentMethodSettingsId: string;
  paymentMethodExceptionData: PaymentMethodExceptionLimitCreateModel;
};

export type PaymentMethodExceptionLimitDeleteRequestPayload = {
  paymentMethodSettingsId: string;
  exceptionLimitId: string;
};

export type PaymentMethodExceptionLimitUpdateModel = {
  exceptionLimitId: string;
  paymentMethodExceptionData: PaymentMethodExceptionLimitCreateModel;
};

export type PaymentMethodExceptionLimitUpdateRequestPayload = PaymentMethodExceptionLimitCreateRequestPayload & {
  exceptionLimitId: string;
};

export enum PaymentMethodInfoLabel {
  INTERNAL_NAME = 'Internal name',
  PUBLIC_NAME = 'Public name',
  BILLING_PROVIDER = 'Billing provider',
}

export type PaymentMethodInfoField = {
  label: PaymentMethodInfoLabel;
  value?: string;
};
